import { render, staticRenderFns } from "./filtro.vue?vue&type=template&id=5c0fc2aa&scoped=true"
import script from "./filtro.vue?vue&type=script&lang=js"
export * from "./filtro.vue?vue&type=script&lang=js"
import style0 from "./filtro.vue?vue&type=style&index=0&id=5c0fc2aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0fc2aa",
  null
  
)

export default component.exports